"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItemStreamEvent = void 0;
const state_1 = require("../../state");
const Complete = 'Complete';
exports.ItemStreamEvent = Object.assign(Object.assign({}, state_1.StateEvent), { Complete });
